import { Route, Switch } from 'react-router-dom'

import SelectLibraryDistrict from '@main/customizations/nevada/components/SelectLibraryDistrict'

import CombineParentsWrapper from './combine/CombineParentWrapper'
import { CombineAccountsChoose } from './combine/CombineAccountsChoose'
import { CombineAccountsAuth } from './combine/CombineAccountsAuth'

export function AuthRoutes() {
  return (
    <Switch>
      <Route path="/register/info/nvlibraries">
        <SelectLibraryDistrict />
      </Route>
      <Route path="/combine">
        <CombineParentsWrapper>
          <Switch>
            <Route path="/combine" exact>
              <CombineAccountsChoose />
            </Route>
            <Route path="/combine/auth">
              <CombineAccountsAuth />
            </Route>
          </Switch>
        </CombineParentsWrapper>
      </Route>
    </Switch>
  )
}
